import {number_format} from "@/helpers/number_format";

export function currency(value, decimals) {
    decimals = (typeof decimals === 'undefined') ? 2 : decimals;
    return number_format(value, decimals,'.', ',');
}
